import { defineStore } from "pinia";
import AuthService from "../services/auth.service.ts";
import { newCache } from "../utils/cache";

const THREE_MINS = 3 * 60 * 1000;
const adminCache = newCache(THREE_MINS);

export const useAdminStore = defineStore("admin", {
  state: () => ({
    loggedIn: false,
    user: null,
    userFetchedAt: null,
    theme: null,
    themeFetchedAt: null,
    serverUpdateDismissed: false,
    userLimitExceededDismissed: false,
    incompatibleAgentAlertDismissed: false,
  }),

  persist: {
    pick: ["user", "userFetchedAt", "theme", "themeFetchedAt"],
  },

  actions: {
    async login(userInput) {
      try {
        await AuthService.adminLogin(userInput);
        this.loggedIn = true;
      } catch (err) {
        this.resetAndClearPersisted();
        throw err;
      }
    },

    async fetchStatus(options = {}) {
      try {
        const user = await adminCache({
          state: this,
          key: "user",
          fetchFn: () => AuthService.adminStatus(),
          ...options,
        });
        this.loggedIn = !!user;
        return user;
      } catch (err) {
        this.resetAndClearPersisted();
        throw err;
      }
    },

    async fetchTheme(options = {}) {
      try {
        await adminCache({
          state: this,
          key: "theme",
          fetchFn: async () => {
            const response = await AuthService.getTheme();
            return response.data;
          },
          ...options,
        });
        return this.theme.Accent;
      } catch (err) {
        return "grape";
      }
    },

    async fetchHighAccessibility(options = {}) {
      try {
        await adminCache({
          state: this,
          key: "theme",
          fetchFn: async () => {
            const response = await AuthService.getTheme();
            return response.data;
          },
          ...options,
        });
        return this.theme.HighAccessibility;
      } catch (err) {
        return false;
      }
    },
    dismissServerUpdate() {
      this.serverUpdateDismissed = true;
    },

    dismissIncompatibleAgentAlert() {
      this.incompatibleAgentAlertDismissed = true;
    },

    dismissUserLimitExceeded() {
      this.userLimitExceededDismissed = true;
    },

    async logout() {
      try {
        await AuthService.adminLogout();
      } finally {
        this.resetAndClearPersisted();
      }
    },

    hasFreshUser() {
      if (!this.user || !this.userFetchedAt) {
        return false;
      }
      return Date.now() - this.userFetchedAt < THREE_MINS;
    },
  },
});
